import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { IoSearchCircle } from "react-icons/io5";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import { NormalInput } from "../NormalInput";
import "./style.scss";
import ReactDOM from "react-dom";

let deviceWidth = window.innerWidth;
export class SearchInputKeyboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      layoutName: "default",
      keyboardVisibility: false,
      keyboardToogleStatus: false,
      inputValue: this.props.parentPassIntialValue || "",
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    // this.clickHanlder = this.clickHanlder.bind(this);
  }

  componentDidMount = async () => {
    this.props.onRef(this);
    document.addEventListener("click", this.handleClickOutside, true);

    if (this.props.parentPassIntialValue) {
      this.setState({ inputValue: this.props.parentPassIntialValue });
    }
    // const myElement = document.getElementsByClassName("keyboardInputSearchCmp");
    // myElement.className += `${this.props.positionAlignmentLeft}`;
    // console.log("myElement", myElement);

    //
  };
  componentDidUpdate(prevProps) {
    if (this.props.parentPassIntialValue !== prevProps.parentPassIntialValue) {
      this.setState({ inputValue: this.props.parentPassIntialValue });
    }
  }

  componentWillUnmount = () => {
    document.removeEventListener("click", this.handleClickOutside, true);
  };

  // handleClickOutside
  handleClickOutside = (event) => {
    const input = this.state.inputValue;
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(event.target)) {
      this.setState({
        keyboardVisibility: false,
        keyboardToogleStatus: false,
        inputValue: input,
      });
    }
  };

  handleShift = () => {
    const newLayoutName =
      this.state.layoutName === "default" ? "shift" : "default";
    this.setState({ layoutName: newLayoutName });
  };

  onKeyBoardPress = (button) => {
    console.log("button" + button);
    if (button === "{bksp}") {
      console.log("this.state.inputValue", this.state.inputValue);
      let sliceValue = this.state.inputValue.slice(0, -1);
      this.setState({ inputValue: sliceValue });
      this.keyboard.setInput(sliceValue);
    }
    if (button === "{enter}") {
      this.handleToHideShowKeyboard();
    }
    if (button === "{shift}" || button === "{lock}") this.handleShift();
  };

  // handleToFoucsInput
  handleToFoucsInput = async (elem) => {
    let ele = null;
    if (elem) ele = elem;
    // console.log(this.state.inputValue, "inputfckey");
    this.handleToHideShowKeyboard();

    // The input will lose focus after 3 seconds
    const searchTextInput = await document.getElementById(ele);

    if (searchTextInput) {
      searchTextInput.focus();
      searchTextInput.blur();
    }
  };

  // hide and show keyboard input
  handleToHideShowKeyboard = async () => {
    await this.setState((prevState) => ({
      keyboardToogleStatus: !prevState.keyboardToogleStatus,
    }));
    if (this.state.keyboardToogleStatus) {
      this.setState({ keyboardVisibility: true });
      if (this.props.keyboardModalValue) {
        this.props.handleHideModal(false);
      }
    } else {
      this.setState({ keyboardVisibility: false });
    }
  };

  handleToCloseKeyboard = async () => {
    await this.setState({
      keyboardVisibility: false,
      keyboardToogleStatus: false,
    });
  };

  // parent
  handleParent = () => {
    this.handleToCloseKeyboard();
    this.props.handleIconSearch();
  };

  // handleChangeInput

  onChangeKeyboardInput = async (e) => {
    await this.setState((prevState) => ({
      ...prevState,
      inputValue: e,
    }));
    this.keyboard.setInput(e);
    this.props.onChangeTextInput(e);
  };

  parentDataUpdate = async (data) => {
    await this.setState((prevState) => ({
      ...prevState,
      inputValue: data,
    }));
    this.keyboard.setInput(data);
  };

  render() {
    let {
      focusValue,
      disabled = false,
      placeHolderText = "",
      isSearchIcon = true,
      positionAlignmentLeft = "",
      positionAlignmentRight = "",
    } = this.props;

    return (
      <div className="d-flex w-100 align-items-center">
        <div className={` ${isSearchIcon ? "col-9" : "col-12"} p-0 `}>
          <div className="input-group">
            <div className="searchInputContainer">
              <NormalInput
                id={focusValue}
                placeholder={placeHolderText}
                value={this.state.inputValue}
                name="outlet"
                // onChange={this.handleChangeInput}
                onFocus={() => this.handleToFoucsInput(focusValue)}
                disabled={disabled}
              />

              <div
                className={`${
                  this.state.keyboardVisibility ? "d-block" : "d-none"
                }  ${
                  deviceWidth <= 1250
                    ? positionAlignmentLeft
                    : positionAlignmentRight
                }`}
              >
                <Keyboard
                  keyboardRef={(r) => (this.keyboard = r)}
                  layoutName={this.state.layoutName}
                  onChange={(val) => this.onChangeKeyboardInput(val)}
                  onKeyPress={(btnType) => this.onKeyBoardPress(btnType)}
                  style={{ zIndex: -1 }}
                />
              </div>
            </div>
          </div>
        </div>
        {isSearchIcon && (
          <div
            className="col-3 border-primary pl-0 cursor-pointer"
            onClick={this.handleParent}
          >
            <IoSearchCircle color="#023f88" size={55} />
          </div>
        )}
      </div>
    );
  }
}

// export const SearchInputKeyboard = withTranslation()(SearchInputKeyboardClass);
export default SearchInputKeyboard;
